import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api/api";
import { toast } from "react-toastify";
import { getUserLocation } from "../../components/getLocation";

const DEFAULT_LOCATION = {
  latitude: 5.0389,
  longitude: 7.9094,
};

export const UpdateLocation = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleUpdateLocation = async () => {
    setLoading(true);

    let latitude = DEFAULT_LOCATION.latitude;
    let longitude = DEFAULT_LOCATION.longitude;

    try {
      const coords = await getUserLocation();

      // Validate coords before using
      if (
        coords &&
        typeof coords.latitude === "number" &&
        typeof coords.longitude === "number"
      ) {
        latitude = coords.latitude;
        longitude = coords.longitude;
      } else {
        toast.info("Using default location (Uyo)");
      }
    } catch (err) {
      console.warn("GPS failed, falling back to default:", err);
      toast.info("Location access failed. Using default location (Uyo)");
    }

    try {
      const res = await api.kyc.updateLocation({
        latitude,
        longitude,
      });

      if (res?.status) {
        localStorage.setItem("hasLocation", "true");
        toast.success("Location updated successfully");
        navigate(-1);
      } else {
        toast.warn("Failed to update location");
      }
    } catch (err) {
      console.error(err);
      toast.warn("Failed to update location");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#fff8e1]">
      <div className="app-container [font-family:'Nunito',Helvetica] text-[#5d4037] pb-6 w-full max-w-md">

        {/* Top bar */}
        <div className="w-full flex items-center mt-4">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="ml-4 w-9 h-9 rounded-full bg-[#ccb357] grid place-items-center"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" stroke="#5d4037" strokeWidth="2" viewBox="0 0 24 24">
              <path d="M15 18l-6-6 6-6" />
            </svg>
          </button>
          <h1 className="flex-1 text-center font-bold text-[18px]">
            Update Location
          </h1>
          <div className="w-9" />
        </div>

        {/* Icon */}
        <div className="mt-8 w-full flex justify-center">
          <div className="w-[96px] h-[96px] rounded-full bg-[#eadfb7] grid place-items-center border-[3px] border-[#cdb966]">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="#5d4037" viewBox="0 0 24 24">
              <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5S13.38 11.5 12 11.5z" />
            </svg>
          </div>
        </div>

        {/* Text */}
        <p className="mt-5 text-center font-extrabold text-[18px]">
          Enable Your Location
        </p>
        <p className="mt-2 text-center text-[14px] w-[320px] mx-auto">
          We’ll use your location to personalize services and improve deliveries
        </p>

        {/* Button */}
        <div className="mt-8 px-6">
          <button
            type="button"
            onClick={handleUpdateLocation}
            disabled={loading}
            className={`w-full py-3 rounded-full font-bold text-[16px] transition ${
              loading
                ? "bg-gray-300 text-gray-500"
                : "bg-[#5d4037] text-[#fff8e1]"
            }`}
          >
            {loading ? "Updating location..." : "Use Current Location"}
          </button>
        </div>

        {/* Skip */}
        <div className="mt-4 text-center">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="text-[14px] underline opacity-80"
          >
            Skip for now
          </button>
        </div>

        <div className="mt-8 w-[260px] h-[8px] rounded-full bg-[#5d4037] mx-auto" />
      </div>
    </div>
  );
};
